import "@/style.css";
import "@xs2event/js-lib/style";
import { setLocale } from "@xs2event/js-lib/util";
// -------------------------------

import App from "@/App.vue";
import { createApp } from "vue";
import pinia from "@/store.js";
import { useUserStore } from "@/store/user";
import { newRouter } from "@/router.js";
import VueGtag from "vue-gtag";
import { i18n } from "./i18n";
import { initLocales } from "@/components/page/menu/locales.js";
import brandconfig from "@/brandconfig.js";
import { isBranded } from "@/brandconfig.js";

import { xs2eventPlugin } from "@xs2event/js-lib/plugins";
import { config, isLocal } from "./config";
import { VueQueryPlugin } from "@tanstack/vue-query";
import { enableAppendZ, setApiPath } from "@xs2event/js-lib/api";

// -------------------------------

const app = createApp(App);
app.use(i18n);
app.use(pinia);
app.use(VueQueryPlugin);

app.use(xs2eventPlugin, {
  development: isLocal,
  branded: isBranded,
  locales: brandconfig.lang,
  sentryDsn: config.SENTRY_DSN,
  appName: config.WEBAPP,
  version: config.VERSION,
  apiPath: config.API_URL,
  cdnPath: config.CDN_URL,
  strapiUrl: config.STRAPI_API_URL,
});

useUserStore();
const router = newRouter();

// initializeSentry(app, router); // preferred way of init

app.use(
  {
    defaultName: window.location.href,
    defaultLocale: i18n.global.locale.value,
    locales: brandconfig.locales,
    preconnect: [config.CDN_URL, config.API_URL],
  },
  router
);
app.use(router);

if (brandconfig.GA_ID !== "") {
  app.use(VueGtag, {
    config: { id: brandconfig.GA_ID },
    router,
    enabled: true,
  });
  app.provide("gtag", app.config.globalProperties.$gtag);
}

initLocales();
setLocale(localStorage.AcceptedLanguage || "en").then(() => {});

// Enable AppendZ flag.
enableAppendZ();

setApiPath(config.API_URL.replace("/v1", ""));

app.mount("#app");
